import { render, staticRenderFns } from "./sales-orders-list.vue?vue&type=template&id=2590ffb5&scoped=true&"
import script from "./sales-orders-list.vue?vue&type=script&lang=js&"
export * from "./sales-orders-list.vue?vue&type=script&lang=js&"
import style0 from "./sales-orders-list.vue?vue&type=style&index=0&id=2590ffb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2590ffb5",
  null
  
)

export default component.exports